module.exports = __webpack_public_path__ + "img/20000元年.e9697e4e.png";